<template>
  <div
    v-if="tags.length === 0"
    class="no-tags-message"
  >
    No tags in group.
  </div>
  <div
    v-for="(tag, index) in $props.tags"
    :key="tag.tagId"
    class="tag-matrix-data-option-holder"
  >
   <TagMatrixDataOption
      :tag="tag"
      :is-back="isBack"
      :type="type"
    />
  </div>
</template>

<script>   
import TagMatrixDataOption from '@/components/rmt/tag_matrix/TagMatrixDataOption';

export default {
  name: 'TagMatrixData',
  components: {
    TagMatrixDataOption
  },
  props: [
      'tags',
      'isBack',
      'type'
  ],
  data () {
    return {
      isChecked : false
    };
  },
  methods: {
    handleCheck () {
      this.isChecked = !this.isChecked;
    }
  }
};
</script>

<style scoped>
.tag-matrix-data-option-holder {
  height: 30px;
  display: flex;
  flex: 1;
}
.no-tags-message {
  margin: 5px 10px 10px 20px;
  font-size: .83em;
}
</style>